import moment from 'moment';
import React, {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';
import {IGroupProtocolDto} from 'pages/ais/organization-structure-v5/api/types';
import {GroupCompanyProtocolModal} from 'pages/ais/organization-structure-v5/ui/forms/group-company-protocol-form';
import {DATE_DMY} from 'shared/constants/date-format';

export const useGroupProtocolColumns = (
    tableData: IGroupProtocolDto[] | undefined,
): IUseCustomTableArgs['columns'] =>
    useMemo(
        () => [
            {
                title: 'Номер запроса',
                dataIndex: 'requestId',
                render: (_: number, fields: IGroupProtocolDto) => (
                    <GroupCompanyProtocolModal
                        value={fields.id}
                        fields={fields}
                    />
                ),
            },
            {
                title: 'Дата получения запроса',
                dataIndex: 'requestDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY),
            },
            {title: 'ИНН организации', dataIndex: 'inn'},
            {
                title: 'Дата, по состоянию на которую предоставляются сведения',
                dataIndex: 'reportingDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY),
            },
        ],
        [tableData]
    );